/**
 * Conf Lists.
 * An extension of the native TinyMce lists
 * Copyright 2017, Atlassian
 *
 * Proprietary behaviours:
 *  - handle toolbar outdent state when cursor is in a list
 *
 */

import window from 'window-or-global';

export default function confList() {
	const plugger = () => {
		return {
			init: (ed) => {
				ed.editorCommands.addCommands(
					{
						// handles outdent states on the toolbar when in a list
						outdent() {
							const sel = ed.selection;
							const dom = ed.dom;

							function hasStyleIndent(n) {
								n = dom.getParent(n, dom.isBlock);
								return (
									n &&
									parseInt(ed.dom.getStyle(n, 'margin-left') || 0, 10) +
										parseInt(ed.dom.getStyle(n, 'padding-left') || 0, 10) >
										0
								);
							}

							return (
								hasStyleIndent(sel.getStart()) ||
								hasStyleIndent(sel.getEnd()) ||
								ed.queryCommandState('InsertOrderedList') ||
								ed.queryCommandState('InsertUnorderedList') ||
								ed.queryCommandState('InsertInlineTaskList')
							);
						},
					},
					'state',
				);
			},
		};
	};

	window.tinymce.create('tinymce.plugins.ConfList', plugger());
	window.tinymce.PluginManager.add('conflist', window.tinymce.plugins.ConfList);
}
